/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {BaseElementOut} from './BaseElementOut';
import {
  BaseElementOutFromJSON,
  BaseElementOutFromJSONTyped,
  BaseElementOutToJSON
} from './BaseElementOut';
import type {ElementClassName} from './ElementClassName';
import {
  ElementClassNameFromJSON,
  ElementClassNameFromJSONTyped,
  ElementClassNameToJSON
} from './ElementClassName';

/**
 *
 * @export
 * @interface ElementImportOut
 */
export interface ElementImportOut {
  /**
   *
   * @type {string}
   * @memberof ElementImportOut
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof ElementImportOut
   */
  name: string;
  /**
   *
   * @type {ElementClassName}
   * @memberof ElementImportOut
   */
  type: ElementClassName;
  /**
   *
   * @type {boolean}
   * @memberof ElementImportOut
   */
  deletable?: boolean;
  /**
   *
   * @type {Array<BaseElementOut>}
   * @memberof ElementImportOut
   */
  subElements?: Array<BaseElementOut> | null;
  /**
   *
   * @type {boolean}
   * @memberof ElementImportOut
   */
  treeChanged?: boolean;
}

/**
 * Check if a given object implements the ElementImportOut interface.
 */
export function instanceOfElementImportOut(value: object): value is ElementImportOut {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function ElementImportOutFromJSON(json: any): ElementImportOut {
  return ElementImportOutFromJSONTyped(json, false);
}

export function ElementImportOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ElementImportOut {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    type: ElementClassNameFromJSON(json['type']),
    deletable: json['deletable'] == null ? undefined : json['deletable'],
    subElements:
      json['sub_elements'] == null
        ? undefined
        : (json['sub_elements'] as Array<any>).map(BaseElementOutFromJSON),
    treeChanged: json['tree_changed'] == null ? undefined : json['tree_changed']
  };
}

export function ElementImportOutToJSON(value?: ElementImportOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    type: ElementClassNameToJSON(value['type']),
    deletable: value['deletable'],
    sub_elements:
      value['subElements'] == null
        ? undefined
        : (value['subElements'] as Array<any>).map(BaseElementOutToJSON),
    tree_changed: value['treeChanged']
  };
}
